import * as React from 'react'
import { LoaderCircle } from 'lucide-react'
import { type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'
import { spinnerVariants } from './spinner.variants'

type SpinnerProps = Omit<React.ComponentProps<typeof LoaderCircle>, 'size'> &
  VariantProps<typeof spinnerVariants>

function Spinner({ className, size, ...props }: SpinnerProps) {
  return (
    <LoaderCircle
      data-slot='spinner'
      role='status'
      aria-label='Loading'
      className={cn(spinnerVariants({ size }), className)}
      {...props}
    />
  )
}

export { Spinner }
